module.exports = __webpack_public_path__ + "static/media/storie_02.dded4315.jpg";